export const HIGH_SCORE = 85;
export const VALIDITY_DAYS = 90;
export const DAYS_OF_DATA = 30;
export const WEIGHTS = {
  HIGH: 0.5,
  MEDIUM: 0.35,
  LOW: 0.15,
};
